/* RAJ layout fit: (1) on phones every section heading stays on one line — long ones shrink to fit the screen;
   (2) scroll-row buttons under the cards hide when nothing scrolls and grey out at either end;
   (3) phone trust-badge row: auto-scrolls in an endless loop and can also be swiped by hand;
   (4) product rows marked data-raj-drag can be dragged sideways with the mouse on desktop. */
(function () {
  'use strict';
  var SEL = '.raj-section__head .raj-heading, .raj-story3__copy .raj-heading, .section__heading';
  var MIN = 18;
  var mq = window.matchMedia('(max-width: 767px)');

  function room(h) {
    var box = h.closest('.raj-section__head, .raj-story3__box, .section__header') || h.parentElement;
    var cs = getComputedStyle(box);
    return box.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
  }
  function natural(h) {
    var tag = h.querySelector('.raj-newtag-wrap'), wrap = h.style.flexWrap;
    if (tag) tag.style.display = 'none';
    h.style.flexWrap = 'nowrap';
    var w = h.scrollWidth;
    if (tag) tag.style.display = '';
    h.style.flexWrap = wrap;
    return w;
  }
  function fit() {
    document.querySelectorAll(SEL).forEach(function (h) {
      h.style.fontSize = '';
      if (!mq.matches || !h.offsetParent) return;
      var size = parseFloat(getComputedStyle(h).fontSize), avail = room(h), w = natural(h);
      for (var i = 0; i < 24 && w > avail && size > MIN; i++) {
        size = Math.max(MIN, Math.floor(size * avail / w * 10) / 10 - 0.2);
        h.style.fontSize = size + 'px';
        w = natural(h);
      }
    });
  }
  function rows() {
    document.querySelectorAll('[data-raj-row]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-raj-track]'), nav = wrap.querySelector('.raj-arrows--below');
      if (!track || !nav) return;
      var max = track.scrollWidth - track.clientWidth, b = nav.querySelectorAll('[data-dir]');
      nav.classList.toggle('is-static', max <= 4);
      if (b[0]) b[0].disabled = track.scrollLeft <= 4;
      if (b[1]) b[1].disabled = track.scrollLeft >= max - 4;
      if (!track._rajFit) { track._rajFit = 1; track.addEventListener('scroll', function () { clearTimeout(track._rajT); track._rajT = setTimeout(rows, 60); }, { passive: true }); }
    });
  }
  function loops() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('.raj-badges-vp--loop:not([data-loop])').forEach(function (vp) {
      vp.setAttribute('data-loop', '1');
      var track = vp.firstElementChild, pos = 0, set = -1, hold = 0, seen = true, last = 0;
      var secs = parseFloat(getComputedStyle(track).getPropertyValue('--raj-badge-speed')) || 26;
      function pause(ms) { hold = Math.max(hold, Date.now() + ms); }
      vp.addEventListener('touchstart', function () { pause(60000); }, { passive: true });
      vp.addEventListener('touchend', function () { hold = Date.now() + 2500; }, { passive: true });
      vp.addEventListener('pointerdown', function () { pause(2500); });
      vp.addEventListener('wheel', function () { pause(2500); }, { passive: true });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { seen = en[0].isIntersecting; }).observe(vp);
      function frame(ts) {
        requestAnimationFrame(frame);
        var dt = last ? Math.min(ts - last, 100) : 0; last = ts;
        if (!mq.matches || reduce) return;
        var half = track.scrollWidth / 2;
        if (half <= vp.clientWidth) return;
        var now = vp.scrollLeft;
        if (set >= 0 && Math.abs(now - set) > 2) pause(2500);   // moved by a swipe, momentum or trackpad
        if (now >= half) { now -= half; vp.scrollLeft = now; }   // endless both ways
        else if (now <= 0 && Date.now() < hold) { now += half; vp.scrollLeft = now; }
        if (Date.now() < hold || !seen || document.hidden) { pos = now; set = -1; return; }
        if (set < 0) pos = now;
        pos += half / secs * dt / 1000;
        if (pos >= half) pos -= half;
        vp.scrollLeft = pos;
        set = vp.scrollLeft;
      }
      requestAnimationFrame(frame);
    });
  }
  function drags() {
    document.querySelectorAll('[data-raj-drag]:not([data-drag])').forEach(function (track) {
      track.setAttribute('data-drag', '1');
      var x0 = 0, s0 = 0, down = false, moved = false;
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; moved = false; x0 = e.clientX; s0 = track.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - x0;
        if (!moved && Math.abs(dx) < 6) return;
        if (!moved) { moved = true; track.classList.add('is-dragging'); }
        track.scrollLeft = s0 - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!down) return;
        down = false;
        if (!moved) return;
        // let the row snap to the nearest card again, and swallow the click that ends the drag
        var left = track.scrollLeft;
        track.classList.remove('is-dragging');
        track.scrollLeft = left;
        setTimeout(function () { moved = false; }, 0);
      });
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    });
  }
  var t;
  function later() { clearTimeout(t); t = setTimeout(function () { fit(); rows(); }, 120); }
  function init() {
    fit();
    rows();
    loops();
    drags();
    window.addEventListener('load', rows);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    window.addEventListener('resize', later);
    if (mq.addEventListener) mq.addEventListener('change', fit);
    document.addEventListener('shopify:section:load', later);
    document.addEventListener('shopify:section:load', drags);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
